<script setup>
import {defineAsyncComponent, defineProps, ref} from 'vue'
import {useRouter} from 'vue-router'
import WhiteListModal from '@/views/ad-account-requests/white-lists/components/WhiteListModal.vue'
import ShareRequestModal from '@/views/ad-account-requests/share-permissions/components/ShareRequestModal.vue'
import AdAccountRenameRequestModal from '@/views/ad-account-requests/rename/AdAccountRenameRequestModal.vue'
import OtherRequestModal from '@/views/ad-account-requests/other-requests/OtherRequestModal.vue'
import ManageFundsModal from '@/views/ad-account-requests/top-up/components/manage-funds-modal/ManageFundsModal.vue'

const RequestTypeModal = defineAsyncComponent(() => import('@/components/ui/requests/RequestTypeModal.vue'))

defineProps({
  isPrimary: {
    type: Boolean,
    default: false,
  },
})

const router = useRouter()
const showRequestTypeModal = ref(false)
const showWhiteListModal = ref(false)
const showManageFundsModal = ref(false)
const showRenameRequestModal = ref(false)
const showSharePermissionModal = ref(false)
const showOtherRequestModal = ref(false)
const selectedOtherRequestType = ref(null)
const pendingRequestType = ref(null)

const openRequestTypeModal = () => {
  showRequestTypeModal.value = true
}

const onRequestTypeSelect = entry => {
  pendingRequestType.value = entry
}

const onRequestTypeModalHidden = () => {
  showRequestTypeModal.value = false

  openSelectedRequestModal()
}

const openSelectedRequestModal = () => {
  const entry = pendingRequestType.value

  if (!entry) {
    return
  }

  pendingRequestType.value = null

  if (entry.otherRequestType) {
    selectedOtherRequestType.value = entry.otherRequestType
    showOtherRequestModal.value = true

    return
  }

  const modalFlagByRequestType = {
    'manage-funds': showManageFundsModal,
    'rename-account': showRenameRequestModal,
    'share-access': showSharePermissionModal,
    whitelist: showWhiteListModal,
  }

  const modalFlag = modalFlagByRequestType[entry.key]

  if (modalFlag) {
    modalFlag.value = true
  }
}

const onOtherRequestModalHidden = () => {
  showOtherRequestModal.value = false
  selectedOtherRequestType.value = null
}

const onShareRequestCreated = () => {
  const resolvedRoute = router.resolve({name: 'share-permissions'})
  window.location.href = resolvedRoute.href
}
const onRenameRequestCreated = () => {
  const resolvedRoute = router.resolve({name: 'ad-account-requests.rename.list'})
  window.location.href = resolvedRoute.href
}
const onManageFundsRequestCreated = () => {
  const resolvedRoute = router.resolve({name: 'ad-account-requests.top-up.list'})
  window.location.href = resolvedRoute.href
}
const onOtherRequestCreated = () => {
  const resolvedRoute = router.resolve({name: 'my-requests.list'})
  window.location.href = resolvedRoute.href
}
const onWhiteRequestCreated = () => {
  const resolvedRoute = router.resolve({name: 'whitelist'})
  window.location.href = resolvedRoute.href
}
</script>

<template>
  <request-type-modal
    v-if="showRequestTypeModal"
    id="new-request-type-modal"
    @select="onRequestTypeSelect"
    @hidden="onRequestTypeModalHidden"
  />
  <manage-funds-modal
    v-if="showManageFundsModal"
    @hidden="showManageFundsModal = false"
    @created="onManageFundsRequestCreated"
    id="new-request-ad-account-manage-funds-modal"
  />
  <ad-account-rename-request-modal
    v-if="showRenameRequestModal"
    @hidden="showRenameRequestModal = false"
    @created="onRenameRequestCreated"
    id="new-request-ad-account-rename-request-modal"
  />
  <share-request-modal
    v-if="showSharePermissionModal"
    @hidden="showSharePermissionModal = false"
    id="new-request-share-request-modal"
    @created="onShareRequestCreated"
  />
  <other-request-modal
    v-if="showOtherRequestModal"
    :request-type="selectedOtherRequestType"
    @created="onOtherRequestCreated"
    @hidden="onOtherRequestModalHidden"
    id="new-request-other-request-modal"
  />
  <white-list-modal
    v-if="showWhiteListModal"
    id="new-request-white-list-modal"
    @hidden="showWhiteListModal = false"
    @created="onWhiteRequestCreated"
  />

  <button
    type="button"
    :class="['btn', isPrimary ? 'btn-primary' : 'btn-secondary']"
    v-bind="$attrs"
    @click="openRequestTypeModal"
  >
    New Request
  </button>
</template>
